import React from 'react';
import { SITE_CONTENT } from '../content';

const ImageCarosel = ({ 
  images = SITE_CONTENT.pages?.aboutUsPage?.imageCarousel?.defaultImages || [] 
}) => {

  const CustomImageList = () => (
    <div className="flex gap-6 shrink-0 w-max pr-6">
      {images.map((src, idx) => (
        <div 
          key={idx} 
          className="shrink-0 w-[80vw] sm:w-[60vw] md:w-[500px] lg:w-[600px] xl:w-[650px] aspect-[4/3] sm:aspect-video overflow-hidden shadow-sm"
        >
          <img 
            src={src} 
            alt={`Carousel view ${idx + 1}`} 
            className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className="w-full bg-[#f0eee5] py-16 overflow-hidden">
      {/* 
        We use a custom keyframe here. By utilizing two identical blocks of images 
        side-by-side and translating them by exactly -50%, we get a perfect infinite loop. 
      */}
      <style>{`
        @keyframes scroll-carousel {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll-carousel {
          animation: scroll-carousel 40s linear infinite;
        }
        .animate-scroll-carousel:hover {
          animation-play-state: paused;
        }
      `}</style>
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 overflow-hidden relative">
        <div className="flex w-max animate-scroll-carousel">
          <CustomImageList />
          <CustomImageList />
        </div>
      </div>
    </div>
  );
};

export default ImageCarosel;
